import { Button } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useRidesWizard, hasRiderDraft, hasDriverDraft, riderMissingStep, driverMissingStep } from '@/store/ridesWizard';
import { useRidesEvents } from '@/lib/lookups';
import { formatDate } from '@/lib/format';
import '@/styles/member.css';

/** "Continue where you left off: finding a ride for Tide Night on Friday, 16 October 2026". */
export function ResumeCard() {
  const navigate = useNavigate();
  const { role, rider, driver, resetRider, resetDriver } = useRidesWizard();
  const { data: events } = useRidesEvents();

  const riderDraft = hasRiderDraft(rider);
  const driverDraft = hasDriverDraft(driver);
  if (!riderDraft && !driverDraft) return null;

  const useRider = riderDraft && (role === 'rider' || !driverDraft);
  const eventId = useRider ? rider.eventId : driver.eventIds[0];
  const ev = events?.find((e) => e.eventID === eventId);
  const what = useRider
    ? 'You were finding a ride'
    : driver.eventIds.length > 1
      ? `You were offering lifts for ${driver.eventIds.length} services or events`
      : 'You were offering a lift';
  const when = ev ? ` for ${ev.name} on ${formatDate(ev.date)}.` : '.';
  const target = useRider
    ? riderMissingStep(rider, 'verify') ?? '/ride/verify'
    : driverMissingStep(driver, 'summary') ?? '/drive/summary';

  return (
    <section className="rm-nudge" style={{ borderColor: 'var(--rides-primary)' }} aria-labelledby="rm-resume-title">
      <div className="body" style={{ paddingRight: 6 }}>
        <h2 id="rm-resume-title">Continue where you left off</h2>
        <p>{what}{when}</p>
        <div className="act">
          <Button variant="light" onClick={() => navigate(target)} rightSection={<IconArrowRight size={18} />}>
            Continue
          </Button>
          <Button variant="subtle" onClick={() => (useRider ? resetRider() : resetDriver())}>
            Clear it
          </Button>
        </div>
      </div>
    </section>
  );
}
